export const uk = {
    'help-title': 'Помощь'
};
